enum TypeSupport {
  GENERAL = 'GENERAL',
  TECHNICAL = 'TECHNICAL',
  BILLING = 'BILLING'
}

export default TypeSupport;
